const config = {
    projectId: "dreico-demo",
    communityName: "Demo",
    productionUrl: "https://demo.dreico.net",
    algoliaIndex: "demo_user",
}

export default config